import React, { FC } from 'react'
import { Box } from '@mui/material'
import Typography from '@mui/material/Typography'
import Loading from './Loading'
import Error from './Error'

interface GlobalLoadingOptions {
  transparent?: boolean,
  message?: string,
  error?: string,
  logs?: string[],
}

interface GlobalLoadingProps extends GlobalLoadingOptions {
  active: boolean,
}

const GlobalLoading: FC<React.PropsWithChildren<GlobalLoadingProps>> = ({
  active,
  transparent = true,
  message = 'loading...',
  error,
  logs = [],
}) => {
  if(!active) return null
  return (
    <Box
      sx={{
        position: 'fixed',
        left: '0px',
        top: '0px',
        zIndex: 10000,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: transparent ?
          'rgba(255, 255, 255, 0.7)' :
          'rgba(255, 255, 255, 1)'
      }}
    >
      <Box
        sx={{
          padding: (theme) => theme.spacing(6),
          backgroundColor: '#ffffff',
          border: '1px solid #e5e5e5',
          //boxShadow: '5px 5px 5px 0px rgba(0,0,0,0.2)',
          //borderRadius: 20,
        }}
      >
        {
          error ? (
            <Error
              message={ error }
            />
          ) : (
            <Loading
              message={ message }
            >
              {
                logs.map((log, i) => {
                  return (
                    <Typography
                      variant="body2"
                      key={ i }
                      sx={{ color: '#999' }}
                    >
                      { log }
                    </Typography>
                  )
                })
              }
            </Loading>
          )
        }
      </Box>
    </Box>
  )
}

export default GlobalLoading